import BoxToFlex from './BoxToFlex'

export default BoxToFlex
